import { Injectable } from '@angular/core';
import { LocalStorageKeys } from './local-storage-keys.constants';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  isOnboardingDone(userId: string): boolean {
    return this._getOnboardingDoneUserIds().includes(userId);
  }

  storeOnboardingDone(userId: string): void {
    const userIds = new Set(this._getOnboardingDoneUserIds());
    userIds.add(userId);
    localStorage.setItem(LocalStorageKeys.ONBOARDING_DONE_USER_IDS, JSON.stringify([...userIds]));
  }

  private _getOnboardingDoneUserIds(): string[] {
    const rawValue = localStorage.getItem(LocalStorageKeys.ONBOARDING_DONE_USER_IDS);
    if (!rawValue) return [];

    try {
      const parsedValue: unknown = JSON.parse(rawValue);
      return Array.isArray(parsedValue) ? parsedValue.filter((id): id is string => typeof id === 'string') : [];
    } catch {
      return [];
    }
  }
}
